import { ITrainingEmployee } from '../common/data/dtos/training-employee';
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from '../helpers/httpHelper';

const BASE_PATH = 'api/TrainingEmployee';

interface TrainingEmployeeResponse {
    success: boolean;
    trainingEmployee?: ITrainingEmployee;
    trainingEmployees?: ITrainingEmployee[];
    error?: string;
}

type CreateITrainingEmployeeType = Omit<ITrainingEmployee, 'id'> | Partial<ITrainingEmployee>;

const createTrainingEmployee = async (employee: CreateITrainingEmployeeType): Promise<TrainingEmployeeResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<ITrainingEmployee>(`${BASE_PATH}`, employee);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const createManyTrainingEmployee = async (trainingEmployees: CreateITrainingEmployeeType[]): Promise<TrainingEmployeeResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<ITrainingEmployee>(`${BASE_PATH}`, trainingEmployees);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteTrainingEmployee = async (id: string): Promise<TrainingEmployeeResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<ITrainingEmployee>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getTrainingEmployees = async (): Promise<TrainingEmployeeResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ITrainingEmployee>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, trainingEmployees: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getOneTrainingEmployee = async (id: string): Promise<TrainingEmployeeResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ITrainingEmployee>(`${BASE_PATH}?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, trainingEmployee: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateTrainingEmployee = async (employee: ITrainingEmployee): Promise<TrainingEmployeeResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<ITrainingEmployee>(`${BASE_PATH}?id=${employee.id}`, employee);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getTrainingEmployeeByEmployee = async (employeeId: string): Promise<TrainingEmployeeResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ITrainingEmployee>(`${BASE_PATH}/GetByEmployee?employeeId=${employeeId}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, trainingEmployees: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getTrainingEmployeesByTraining = async (trainingId: string): Promise<TrainingEmployeeResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ITrainingEmployee>(`${BASE_PATH}/GetByTraining?trainingId=${trainingId}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, trainingEmployees: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createTrainingEmployee,
    createManyTrainingEmployee,
    deleteTrainingEmployee,
    getTrainingEmployees,
    getOneTrainingEmployee,
    updateTrainingEmployee,
    getTrainingEmployeeByEmployee,
};
